












































import {
  Component, Ref, Vue,
} from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form.d';
import { updatePassword } from 'service/api';

@Component
export default class PasswordInfo extends Vue {
  @Ref('form') readonly form!: ElForm;

  passwordInfo = {
    password: '',
    pwd: '',
    pwd1: '',
  };

  passwordRules = {
    password: [
      {
        required: true,
        message: '请输入原密码',
        trigger: 'blur',
      },
    ],
    pwd: [
      {
        required: true,
        message: '请输入要修改的密码',
        trigger: 'blur',
      },
    ],
    pwd1: [
      { validator: this.validatePasswordAgain, required: true, trigger: 'blur' },
    ],
  };

  validatePasswordAgain(rule: object, value: string, callback: (arg0: Error | undefined) => void) {
    if (value === '') {
      callback(new Error('请再次输入密码'));
    } else if (value !== this.passwordInfo.pwd) {
      callback(new Error('两次输入的密码不一致'));
    } else {
      callback(undefined);
    }
  }

  submit() {
    this.form.validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        try {
          const res = await updatePassword({
            password: this.passwordInfo.password,
            pwd: this.passwordInfo.pwd,
          }) as { state: boolean; message: string };
          if (res.state) {
            this.$message.success('修改成功！');
            this.$store.dispatch('Logout').then(() => {
              this.$router.push({ name: 'loginByPassword' }).then(() => window.location.reload());
            });
          } else {
            this.$notify.error(res.message);
          }
        } finally {
          this.loading = false;
        }
      }
    });
  }

  loading = false;
}
